module.exports = __webpack_public_path__ + "img/pencil.a3c3337c.png";